<template>
  <landing-page-form :data="landingPage"
                     :title="$t('searchSuggestions.edit.title', { name: landingPage ? landingPage.title : ''})"
                     :submit-loading="submitLoading"
                     @submit="onSubmit">
  </landing-page-form>
</template>
<script>
  import LandingPageForm from './LandingPageForm'
  import LandingPageService from 'src/services/LandingPageService'
  import LanguageSelect from 'src/components/LanguageSelect'

  export default {
    components: {
      LanguageSelect,
      LandingPageForm,
    },
    data () {
      return {
        submitLoading: false,
        landingPage: null,
      }
    },
    methods: {
      async getData () {
        let {data} = await LandingPageService.getById(this.$route.params.id)
        this.landingPage = data
      },
      async onSubmit (data) {
        try {
          this.submitLoading = true
          await LandingPageService.update(data.id, data)
          this.$router.push('/content/landing-pages')
        } finally {
          this.submitLoading = false
        }
      },
    },
    watch: {
      '$store.state.config.textLanguage' () {
        this.getData()
      },
    },
    async created () {
      await this.getData()
    }
  }
</script>
<style>
</style>
